export default function (nga, admin, menu) {
    var _ename = 'entities';
    var _epretty = 'Entity Reports';
    var _entity = nga.entity(_ename);
    
        
    _entity.listView()
        .title(_epretty)
        .fields([
            nga.field('id').label('ID').isDetailLink(true),
            nga.field('name').label('Name'),
            nga.field('').label('').template('&nbsp;\
            <kts-rights-download-report date="datastore.month" entity="entry.values"></kts-rights-download-report>\n\
            <kts-rights-streaming-report date="datastore.month" entity="entry.values"></kts-rights-streaming-report>\n\
            <kts-rights-spa-report date="datastore.month" entity="entry.values"></kts-rights-spa-report>')
        ]).filters([
            nga.field('m')
                .label('Report Month')
                .pinned(true)
                .template('<div class="input-group"><input type="month" ng-model="datastore.month" placeholder="Month" class="form-control"></input></div>'),
        ])
        .sortField('id')
        .sortDir('asc');

    admin.addEntity(_entity);
    
    menu.addChild(nga.menu(_entity).title(_epretty));
    
    return _entity;
}


// WEBPACK FOOTER //
// ./js/entities/reports.js